
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MyProfileActions } from '../actions/index';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { LegalEntitiesState } from '../my-profile-state';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';

@Injectable()

export class legalEntityEffects {

    constructor(
        private actions$: Actions,
        private readonly apiService: ApiService,
        private globalService: GlobalService,
    ) { }

    protected logger = inject(LoggerService);

    FetchLegalEntity$: Observable<
        ReturnType<typeof MyProfileActions.fetchLegalEntityListSuccess> |
        ReturnType<typeof MyProfileActions.fetchLegalEntityListFail>
    > = createEffect(() =>
        this.actions$.pipe(
            ofType(MyProfileActions.fetchLegalEntityList),
            switchMap((action) => this.apiService.getLegalEntity(action)),
            map((data: LegalEntitiesState) => {
                this.globalService.loadingSubject.next(false);
                return MyProfileActions.fetchLegalEntityListSuccess({ legalEntities: data.legalEntities });
            }),
            catchError((error) =>
                of(MyProfileActions.fetchLegalEntityListFail({ payload: tryNormalizeHttpError(error, this.logger) }))
            )
        )
    );

}